/** Plain-object guard: excludes null, non-objects, and arrays. */
export function isRecord(value: unknown): value is Record<string, unknown> {
    return value !== null && typeof value === "object" && !Array.isArray(value);
}
